import { fetch } from '@atlassian/eoc-fetch';

import type { SavedSearch, SavedSearches, SaveSearchRequest } from '../../../common/types';

export const getSavedSearchesEndpoint = (): Promise<SavedSearches> => {
	return fetch<SavedSearches>('/v1/alerts/saved-searches');
};

export const createSavedSearchEndpoint = (data: SaveSearchRequest): Promise<SavedSearch> => {
	return fetch<SavedSearch>('/v1/alerts/saved-searches', {
		method: 'POST',
		body: data,
	});
};

export const deleteSearchEndpoint = (id: string): Promise<Response> => {
	return fetch<never>(`/v1/alerts/saved-searches/${id}`, {
		method: 'DELETE',
		responseType: 'headers',
	});
};
